import icone from '@/assets/brand/icone.svg'
import logomarca from '@/assets/brand/logomarca.svg'
import { cn } from '@/lib/utils'

/*
  Os dois arquivos vêm da marca sem retoque. A logomarca tem letras pretas e
  fundo transparente, para superfícies claras. O ícone traz o próprio quadrado
  preto, por isso se funde ao --ink do rodapé e serve de favicon.
*/
const SOURCES = {
  full: { src: logomarca, width: 1229, height: 270 },
  icon: { src: icone, width: 512, height: 512 },
} as const

export function Logo({
  className,
  variant = 'full',
}: {
  className?: string
  variant?: keyof typeof SOURCES
}) {
  const { src, width, height } = SOURCES[variant]

  return (
    <img
      src={src}
      alt="Origem Veicular"
      width={width}
      height={height}
      draggable={false}
      className={cn('block h-9 w-auto select-none', variant === 'icon' && 'w-9', className)}
    />
  )
}
